import { API } from '@Providers';

interface EuthanasiaFeePayload {
  euthanasia_fee: string;
  animal_id: string;
  fee_name?: string;
}

export default async function (payload: EuthanasiaFeePayload) {
  const endpoint = '/api/shelter/animal/update-cart-animal-euthanasia-fee';

  return API({ endpoint, method: 'put', payload });
}
